import { GetServerSideProps } from 'next';

import { trackUserEvent } from '../utils/trackUserEvent';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackUserEvent({
    ctx,
  });

  const { locale } = ctx;

  return {
    props: {
      locale: locale || 'pt',
    },
  };
};

export default function PrivacyPolicy({ locale }: { locale: string }) {
  return (
    <>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'center',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span
                style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}
              >
                Privacy Notice&nbsp;
              </span>
            </strong>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            </strong>
          </>
        ) : (
          <>
            <strong>
              <span
                style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}
              >
                Aviso de Privacidade&nbsp;
              </span>
            </strong>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            </strong>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Privacy and security of personal data are extremely important to
            ADSTART. Therefore, this Privacy Notice describes how and what data
            we process to enable your interaction and use of the services
            available on our platform.
          </span>
        ) : (
          <>
            <span
              style={{
                fontFamily: 'Calibri, sans-serif',
                color: 'black',
                backgroundColor: 'rgb(250, 250, 250)',
              }}
            >
              A
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              &nbsp;privacidade e a segurança dos dados pessoais são de extrema
              importância para a ADSTART. Por isso esse Aviso de Privacidade
              descreve como e quais dados processamos para viabilizar a sua
              interação e uso dos serviços disponibilizados em nossa
              plataforma.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            ADSTART is committed to protecting the fundamental rights of freedom
            and privacy regarding the processing of personal data of its users,
            customers, suppliers and partners, in compliance with personal data
            protection regulations, especially the General Data Protection
            Regulation (GDPR).
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>A ADSTART</span>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              se compromete com a proteção dos direitos fundamentais de
              liberdade e de privacidade, relativos ao tratamento de dados
              pessoais dos seus usuários, clientes, fornecedores e parceiros,
              com respeito às normas sobre proteção de dados pessoais,
              sobretudo, a Lei 13.709/2018 – LGPD.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            {locale === 'en' ? 'Definitions:' : 'Definições:'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Data Controller:
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                LAX LTDA,&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              private legal entity, registered under CNPJ No.
              39.429.495/0001-04, headquartered in the city of Blumenau/SC.
            </span>
          </>
        ) : (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Controlador de dados:
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                LAX LTDA,&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              pessoa jurídica de direito privado, inscrita na CNPJ sob nº
              39.429.495/0001-04, com sede na cidade de Blumenau/SC.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Data Processors:&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              We use ADSTART server hosting services from Elasticsearch B.V.
              However, your personal data is not shared by the service provider.
            </span>
          </>
        ) : (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Operadores de dados:&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              Utilizamos os serviços de hospedagem do servidor ADSTART da
              Elasticsearch B.V. Mas seus dados pessoais não são compartilhados
              pelo prestador do serviço.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <strong>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Website:&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              ADSTART domain platform:&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                https://adstart.com.br/
              </span>
            </a>
          </>
        ) : (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Site:&nbsp;
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              plataforma de domínio da ADSTART:&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                https://adstart.com.br/
              </span>
            </a>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>User:</span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              &nbsp;Natural person, holder of personal data, who accesses and
              uses the platform.
            </span>
          </>
        ) : (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Usuário:
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              &nbsp;Pessoa física, titular de dados pessoais, que acessa e
              utiliza a plataforma.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                Profile:
              </span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              &nbsp;user account for accessing and using the ADSTART platform.
            </span>
          </>
        ) : (
          <>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>Perfil:</span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              &nbsp;conta de usuário para acesso e uso da plataforma ADSTART.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <u>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              The purposes for processing your personal data:&nbsp;
            </span>
          </u>
        ) : (
          <u>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              As finalidades para o tratamento de seus dados pessoais:&nbsp;
            </span>
          </u>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            ADSTART is a B2B business platform and acts as an e-commerce service
            provider. The personal data collected here is strictly for
            registration, access and use of the platform and the services
            provided.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              A&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;é uma plataforma de negócios do tipo B2B e atua como
              prestadora de serviços de e-commerce. Os dados pessoais aqui
              coletados são estritamente para cadastrado, acesso e uso da
              plataforma e os serviços disponibilizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            We also request your personal data, such as name and email for the
            &quot;Contact Us&quot; or &quot;Schedule a Call&quot; communication
            channels.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            Solicitamos ainda seus dados pessoais, como nome e e-mail para o
            canal de comunicação &quot;Fale Conosco&quot; ou &quot;Marcar
            Conversa&quot;.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            {locale === 'en'
              ? 'Types of data processed:'
              : 'Tipos de dados tratados:'}
            &nbsp;
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Personal identification data such as name and email, and the
            indication of the company linked to the user are collected and
            processed.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            São coletados e tratados dados pessoais de identificação como nome e
            e-mail e a indicação da empresa vinculada ao usuário.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            The data is provided by the user and necessary for platform access,
            and failure to provide this data will make it impossible to provide
            the available services.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Os dados são fornecidos pelo usuário e necessários para acesso à
            plataforma e a falta de fornecimento destes dados impossibilitará o
            fornecimento dos serviços disponibilizados.&nbsp;
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Users are responsible for personal data of third parties that are
            used to access and use the platform and confirm having authorization
            from the data subjects for such use, when applicable.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Os usuários são responsáveis por dados pessoais de terceiros que
            forem utilizados para acesso e uso da plataforma e confirmam possuir
            autorização dos titulares para o uso, quando for o caso.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            {locale === 'en' ? 'User Rights:' : 'Direitos do Usuário:'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            As a personal data subject, the user has the right to access any
            personal information we process about them and may request at any
            time confirmation of the processing of their personal data, access
            to processed data and storage time, correction or completion of
            incomplete, incorrect or outdated data, information about the public
            or private organization receiving their shared data, has the right
            to object to any marketing action, and, when possible, has the right
            to personal data portability.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              Na qualidade de titular de dados pessoais, o usuário tem o direito
              de acesso a qualquer informação pessoal que tratamos a seu
              respeito e poderá solicitar a qualquer tempo a confirmação de
              tratamento dos seus dados pessoais, acesso aos dados tratados e
              tempo de armazenamento, correção ou complemento de dados dos dados
              incompletos, incorretos ou desatualizados, sobre a organização
              pública ou privada destinatária do compartilhamento dos seus
              dados, tem o direito de se opor a qualquer ação de marketing, e,
              quando possível, tem o direito à&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              portabilidade
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              de dados pessoais.
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            The user has the right to request the deletion of their personal
            data or to restrict processing, and will be attended to whenever
            applicable, in accordance with personal data protection legislation.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              O usuário tem o direito de solicitar o apagamento de seus&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              dados&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              pessoais ou de&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              restringir&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              o&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              tratamento, e será atendido sempre que for aplicável, de acordo
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;com a legislação de proteção de dados pessoais.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              The user may exercise their rights as a data subject with an
              express request through the channel&nbsp;
            </span>
            <a
              href="mailto:lgpd@adstart.com.br"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                lgpd@adstart.com.br
              </span>
            </a>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              .
            </span>
          </>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              O usuário poderá exercer seus direitos de titular com solicitação
              expressa, através do canal&nbsp;
            </span>
            <a
              href="mailto:lgpd@adstart.com.br"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                lgpd@adstart.com.br
              </span>
            </a>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              .
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            {locale === 'en'
              ? 'Data Retention and Deletion Period:'
              : 'Prazo de retenção e eliminação de dados:'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            We will keep your data only for the period necessary for the
            purposes specified in this Privacy Notice, such as providing ADSTART
            platform services. We may also retain your data for compliance with
            legal obligations and regular exercise of rights.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Manteremos os seus dados somente pelo período necessário para as
            finalidades especificadas neste Aviso de Privacidade, como
            fornecimento dos serviços da plataforma ADSTART. Poderemos ainda
            reter seus dados para cumprimento de obrigação legal e exercício
            regular de direitos.&nbsp;
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Upon user request, we can delete, block or anonymize your data so
            that you are no longer identified, except if we are legally
            authorized or obligated to maintain the personal data, such as in
            cases of pending account issues like payment or redemption or any
            type of unresolved complaint, for legal obligations or regular
            exercise of rights, and also for fraud prevention or user security.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            No caso de solicitação pelo usuário, podemos eliminar, bloquear ou
            anonimizar seus dados para que não seja mais identificado, exceto se
            for legalmente autorizado ou obrigado a manter os dados pessoais,
            como no caso de pendência na sua conta, como pagamento ou resgate ou
            algum tipo de reclamação não solucionada, para obrigações legais ou
            exercício regular de direitos, e ainda para prevenção de fraude ou
            segurança dos usuários.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            {locale === 'en'
              ? 'Sharing your data:'
              : 'O Compartilhamento de seus dados:'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            ADSTART does not share your personal data without your consent,
            except for the purposes specified in this Notice or when there is a
            legal requirement.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              A&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;não compartilha seus dados pessoais sem seu consentimento,
              com exceção para os fins especificados neste Aviso ou quando
              houver uma exigência legal. &nbsp;&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            ADSTART may share your necessary data for the execution of some
            services in the platform&apos;s operation with the operators
            described in the definitions of this Notice. The operators who act
            on behalf of ADSTART process the data solely for the contracted
            services and according to our instructions, faithfully complying
            with personal data protection legislation and information security
            standards.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              A&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              ADSTART poderá compartilhar seus dados necessários para a execução
              de alguns serviços na operacionalidade da plataforma, com os
              operadores descritos nas definições deste Aviso. Os operadores que
              atuam em nome da ADSTART
            </span>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              tratam os dados unicamente para os serviços contratados e de
              acordo com as nossas instruções, cumprindo fielmente com a
              legislação de proteção de dados pessoais e como as normas de
              segurança da informação. &nbsp;&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            {locale === 'en' ? 'Security Measures' : 'Medidas de Segurança'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Privacy and security of personal data are very important to ADSTART
            and our security program is complex with the implementation of
            appropriate technical and organizational measures to protect your
            personal data and ensure confidentiality and integrity, aiming that
            they are not disclosed, except in authorized form or with user
            consent.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              A privacidade e a segurança dos dados pessoais são muito
              importantes para a&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              e nosso programa de segurança é complexo com a implementação de
              medidas técnicas e organizacionais apropriadas para proteger os
              seus dados pessoais e garantir a confidencialidade e integridade,
              visando que não sejam divulgados, exceto na forma autorizada ou
              com o consentimento do usuário.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span
          style={{
            fontFamily: 'Calibri, sans-serif',
            color: 'rgb(34, 35, 38)',
          }}
        >
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span
            style={{
              fontFamily: 'Calibri, sans-serif',
              color: 'rgb(34, 35, 38)',
            }}
          >
            It is important for users to protect their account by creating a
            strong password, not sharing it with anyone, limiting access through
            their devices, and avoiding automatic login.
          </span>
        ) : (
          <span
            style={{
              fontFamily: 'Calibri, sans-serif',
              color: 'rgb(34, 35, 38)',
            }}
          >
            Importante o usuário proteger sua conta, com criação de senha forte,
            não compartilhando com ninguém, limitando o acesso através dos seus
            dispositivos e evitando o acesso automático.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span
          style={{
            fontFamily: 'Calibri, sans-serif',
            color: 'rgb(34, 35, 38)',
          }}
        >
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            {locale === 'en'
              ? 'International Transfer'
              : 'Transferência Internacional'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            When international transfer of user data is necessary, we seek to do
            so in countries with Data Protection legislation, with guarantees
            from operators that maintain adequate security levels.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            Quando necessário a transferência internacional de dados dos
            usuários, procuramos fazer em países com legislação em Proteção de
            Dados, com garantias dos operadores que mantenham níveis de
            segurança adequados.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            {locale === 'en' ? 'Legitimate Interest' : 'Legítimo Interesse'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <strong>
          <em>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;
            </span>
          </em>
        </strong>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            Occasionally, we process your personal data under the legal basis of
            legitimate interest. In such cases, we conduct a complete Legitimate
            Interest Assessment (LIA) to ensure that we weigh the rights and
            expectations of the user and any risks that our legitimate interest
            may pose to the users&apos; own interests, ensuring they are
            proportional and appropriate.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              Ocasionalmente tratamos seus dados pessoais sob a base legal do
              legítimo interesse. Nesse caso, realizamos uma avaliação completa
              dos interesses legítimos (LIA) para garantir que pesamos os
              direitos e expectativas do usuário e qualquer risco que nosso
              interesse legítimo pode representar aos próprios
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              interesses dos usuários,
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              garantindo que eles sejam&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              proporcionais
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              &nbsp;e apropriados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
          marginTop: '0cm',
          backgroundColor: 'white',
        }}
      >
        <strong>
          <u>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              {locale === 'en'
                ? 'Notice about changes'
                : 'Aviso sobre alterações'}
            </span>
          </u>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
          marginTop: '0cm',
          backgroundColor: 'white',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
          marginTop: '0cm',
          backgroundColor: 'white',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            In case of changes or updates involving this Privacy Policy, it will
            be updated and we will use the information according to the most
            updated privacy policy.
          </span>
        ) : (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            No caso de alterações ou novidades que envolvam esta Política de
            Privacidade, este será atualizado e faremos uso das informações
            conforme a política de privacidade mais atualizada.
          </span>
        )}
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <u>
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            {locale === 'en'
              ? 'Personal Data Subject Communication Channel:'
              : 'Canal de comunicação do titular de dados pessoais:'}
          </span>
        </u>
      </p>
      <p
        style={{
          margin: '0cm 0cm 6pt',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <strong>
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            &nbsp;
          </span>
        </strong>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
            ADSTART processes your personal data in accordance with this Privacy
            Notice and data protection legislation, especially the General Data
            Protection Regulation (GDPR).
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              A&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>ADSTART</span>
            <strong>
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>&nbsp;</span>
            </strong>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              trata seus dados pessoais em conformidade com este Aviso de
              Privacidade e de acordo com a legislação de proteção de
              dados,&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              sobretudo, a Lei 13.709/2018 – LGPD.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              If you have any questions or wish to make a request or complaint
              about our personal data processing activities, you can submit a
              request to our Data Protection Officer through the channel
            </span>
            <a
              href="mailto:lgpd@adstart.com.br"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                lgpd@adstart.com.br
              </span>
            </a>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              .
            </span>
          </>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              Se tiver alguma dúvida ou deseja fazer uma solicitação ou
              reclamação sobre nossas atividades de tratamento dos seus dados
              pessoais, o usuário pode apresentar uma solicitação ao nosso
              encarregado de dados pessoais através do canal
            </span>
            <a
              href="mailto:lgpd@adstart.com.br"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontFamily: 'Calibri, sans-serif' }}>
                lgpd@adstart.com.br
              </span>
            </a>
            <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
              .
            </span>
          </>
        )}
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          &nbsp;
        </span>
      </p>
    </>
  );
}
